import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from '../message';
import InputPengeluaranService from '../../services/inputPengeluaranServices';
import { clearAuth } from 'store/auth';

export const getList = createAsyncThunk(
  'inputPengeluaran/list',
  async ({ page, perPage, sort, orderBy, search, cabangId, expenseType, month, year }, thunkAPI) => {
    try {
      const response = await InputPengeluaranService.getList(
        page,
        perPage,
        sort,
        orderBy,
        search,
        cabangId,
        expenseType,
        month,
        year
      );
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        thunkAPI.dispatch(clearAuth());
      }
      const message = error.response?.data?.message || error.message || error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const createData = createAsyncThunk('inputPengeluaran/create', async (data, thunkAPI) => {
  try {
    const response = await InputPengeluaranService.create(data);
    thunkAPI.dispatch(setMessage({ message: 'Input pengeluaran berhasil ditambahkan', type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = error.response?.data?.message || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const readData = createAsyncThunk('inputPengeluaran/read', async (id, thunkAPI) => {
  try {
    const response = await InputPengeluaranService.read(id);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = error.response?.data?.message || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const updateData = createAsyncThunk('inputPengeluaran/update', async ({ id, data }, thunkAPI) => {
  try {
    const response = await InputPengeluaranService.update(id, data);
    thunkAPI.dispatch(setMessage({ message: 'Input pengeluaran berhasil diubah', type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = error.response?.data?.message || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const deleteData = createAsyncThunk('inputPengeluaran/delete', async (id, thunkAPI) => {
  try {
    const response = await InputPengeluaranService.del(id);
    thunkAPI.dispatch(setMessage({ message: 'Input pengeluaran berhasil dihapus', type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = error.response?.data?.message || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getListArchive = createAsyncThunk(
  'inputPengeluaran/getListArchive',
  async ({ page, perPage, sort, orderBy, search, cabangId, expenseType, startDate, endDate, createdBy }, thunkAPI) => {
    try {
      const response = await InputPengeluaranService.getListArchive(
        page,
        perPage,
        sort,
        orderBy,
        search,
        cabangId,
        expenseType,
        startDate,
        endDate,
        createdBy
      );
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        thunkAPI.dispatch(clearAuth());
      }
      const message = error.response?.data?.message || error.message || error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const changeStatus = createAsyncThunk('inputPengeluaran/changeStatus', async ({ id, status }, thunkAPI) => {
  try {
    const response = await InputPengeluaranService.changeStatus(id, status);
    thunkAPI.dispatch(setMessage({ message: 'Status berhasil diubah', type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = error.response?.data?.message || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const permanentDelete = createAsyncThunk('inputPengeluaran/permanentDelete', async (id, thunkAPI) => {
  try {
    const response = await InputPengeluaranService.permanentDelete(id);
    thunkAPI.dispatch(setMessage({ message: 'Data berhasil dihapus permanen', type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = error.response?.data?.message || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

const initialState = {
  isLoading: false,
  list: [],
  detail: null,
  archiveList: [],
  error: null
};

const inputPengeluaranSlice = createSlice({
  name: 'inputPengeluaran',
  initialState,
  reducers: {
    clearData: (state) => {
      state.detail = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      })
      .addCase(getList.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(createData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createData.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(createData.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(readData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(readData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.detail = action.payload;
      })
      .addCase(readData.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(updateData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.detail = action.payload;
      })
      .addCase(updateData.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(deleteData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteData.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(deleteData.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getListArchive.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getListArchive.fulfilled, (state, action) => {
        state.isLoading = false;
        state.archiveList = action.payload;
      })
      .addCase(getListArchive.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(changeStatus.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(changeStatus.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(changeStatus.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(permanentDelete.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(permanentDelete.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(permanentDelete.rejected, (state) => {
        state.isLoading = false;
      });
  }
});

export const { clearData } = inputPengeluaranSlice.actions;
const { reducer } = inputPengeluaranSlice;
export default reducer;

